import { render, staticRenderFns } from "./logisReqChanges.vue?vue&type=template&id=22acaead&scoped=true"
import script from "./logisReqChanges.vue?vue&type=script&lang=js"
export * from "./logisReqChanges.vue?vue&type=script&lang=js"
import style0 from "./logisReqChanges.vue?vue&type=style&index=0&id=22acaead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22acaead",
  null
  
)

export default component.exports